/**
 * Download-links (window.open / <a href>) sturen geen headers mee.
 * Daarom hangen we de actieve firma als query-parameter aan de URL,
 * zodat de export de juiste firma-data bevat.
 */
export function metFirma(url) {
  const firmaId = localStorage.getItem("hr_firma");
  if (!firmaId) return url;
  const scheiding = url.includes("?") ? "&" : "?";
  return `${url}${scheiding}firma_id=${encodeURIComponent(firmaId)}`;
}

export function openDownload(url) {
  window.open(metFirma(url), "_blank");
}
